import type { ComponentPropsWithoutRef, ElementRef } from "react"
import React, { forwardRef } from "react"
import { StacksFilled } from "../../icons"
import { Badge } from "./Badge"

export const QuantityBadge = forwardRef<
  ElementRef<typeof Badge>,
  ComponentPropsWithoutRef<typeof Badge>
>(function QuantityBadge({ className, children, iconSize = 14, ...rest }, ref) {
  return (
    <Badge
      className={className}
      {...rest}
      icon={StacksFilled}
      iconSize={iconSize}
      ref={ref}
    >
      {children}
    </Badge>
  )
})
